export default "__VITE_ASSET__DAaobmuz__"